module.exports = __webpack_public_path__ + "img/maps.4bcf744e.png";